import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { FundingProfileData } from '@Types';
import { SpecialUsers, UserId } from '@Services/Api';

export const useFunderProfile = () => {
  const [fetch, response] = useRequest<FundingProfileData>();

  const updateGroupProfile = useCallback(
    (userId: UserId = SpecialUsers.ME) => fetch(API.paths.funding_profile(userId), 'get'),
    [fetch],
  );

  return [updateGroupProfile, response] as const;
};
